/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

   // Start Boost 154584
  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
      if (this.isShow) {
          var searchTerm = Utils.stripHtml(Globals.currentTerm);

          // Product image
          var imageHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
              imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
              imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
          }

          // Product title
          var productTitle = this.customizeProductTitle();
          productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
          
          // SKU
          var skuHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
              skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
              skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
          }

          // Vendor
          var vendorHTML = '';
          if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
              vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
              vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
          }
          // Price
          var priceHTML = this.compileSuggestionProductPrice();
          // Open the result item in new tab when selected
          var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
       
          // Found variant based on search term
          var itemUrl = this.url;
        
          if (this.data.hasOwnProperty('skus')) {
            var variantSKU = this.data.skus.filter(function(skuValue) {
              return skuValue.toLowerCase() == searchTerm.toLowerCase();
            })

            // Found variant ID based on the sku
            var variantID = this.data.variants.filter(function(varID) {
              if (varID.sku === variantSKU[0]) return varID.id;
            })
            
            if (typeof variantSKU[0] !== 'undefined' && typeof variantID[0] !== 'undefined') itemUrl += '?variant=' + variantID[0]['id'];
          }

          return this.getTemplate()
              .replace(/{{id}}/g, this.id)
              .replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
              .replace(/{{url}}/g, itemUrl)
              .replace(/{{newTabAttribute}}/g, newTabAttr)
              .replace(/{{itemProductImage}}/g, imageHTML)
              .replace(/{{title}}/g, productTitle)
              .replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
              .replace(/{{itemProductSku}}/g, skuHTML)
              .replace(/{{itemProductVendor}}/g, vendorHTML)
              .replace(/{{itemProductPrice}}/, priceHTML)
              .replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
              .replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
              .replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem)
      } else {
          return '';
      }
  }
  // End Boost 154584

})();